import { render, staticRenderFns } from "./upload.vue?vue&type=template&id=5996a6a4&scoped=true"
import script from "./upload.vue?vue&type=script&lang=ts"
export * from "./upload.vue?vue&type=script&lang=ts"
import style0 from "./upload.vue?vue&type=style&index=0&id=5996a6a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5996a6a4",
  null
  
)

export default component.exports